module.exports = __webpack_public_path__ + "fonts/euclid-square-500-italic.48ab3dad.ttf";